import { observable, action } from 'mobx';
import { removeOverFlowHidden, overFlowHidden } from '../helpers/reusable.js';
// import userStore from './userStore';
import { Redirect } from 'react-router-dom';
class NavigatorStore {
  @observable yourOrders = false;
  @observable toArtworks = false;
  @observable toProducts = false;
  @observable showSignInModal = false;
  @observable showSignUpModal = false;
  @observable changePasswordForSecurity = false;
  @observable errorModal = false;
  @observable errorMessage = "";
  @observable landingModal = false;
  // @observable errorMessage = "";
  @observable infoModal = false;
  @observable infoMessage = "";
  @observable openArtworkDetails = false;
  @observable OB3Open = false;
  @observable OB2Open = false;
  @observable OB1Open = false;
  @observable openArtistDetails = false;
  @observable openArtworkDetailsId = 0;
  @observable isArtworksPageActive = false;
  @observable isArtistPageActive = false;

  @action toYourOrders() {
    this.yourOrders = true;
    // console.log("navigator worked");
    // userStore.pulluser();
    // return agent.Tags.getAll()

  }

  @action openArtworkDetailsModal(id) {
    // this.openArtworkDetailsId = id
    this.openArtworkDetails = true;
  }

  @action artworksPageActive(bool) {
    // this.openArtworkDetailsId = id
    this.isArtworksPageActive = bool;
  }
  @action artistPageActive(bool) {
    // this.openArtworkDetailsId = id
    this.isArtistPageActive = bool;
  }
  @action closeArtworkDetailsModal() {
    this.openArtworkDetails = false;
    // this.openArtworkDetailsId = 0
  }
  @action openArtistDetailsModal(id) {
    this.openArtistDetails = true;
    overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action closeArtistDetailsModal() {
    this.openArtistDetails = false;
    removeOverFlowHidden()
    // this.openArtworkDetailsId = 0
  }
  @action openOB3Modal(id) {
    this.OB3Open = true;
    overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action closeOB3Modal() {
    this.OB3Open = false;
    removeOverFlowHidden()
    // this.openArtworkDetailsId = 0
  }
  @action openOB2Modal(editMode) {
    this.OB2Open = true;
    this.editMode = editMode;
    overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action displayEditedInterests(interests) {
    this.editedInterestsToDisplay = interests;
    // this.editMode = editMode;
    // overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action displayEditedPreferences(interests) {
    this.editedPreferencesToDisplay = interests;
    // this.editMode = editMode;
    // overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action closeOB2Modal() {
    this.OB2Open = false;
    this.editMode = false;
    removeOverFlowHidden()
    // this.openArtworkDetailsId = 0
  }
  @action openOB1Modal(editMode) {
    this.OB1Open = true;
    this.editMode = editMode
    overFlowHidden()
    // this.openArtworkDetailsId = id
  }
  @action closeOB1Modal() {
    this.OB1Open = false;
    this.editMode = false;
    removeOverFlowHidden()
    // this.openArtworkDetailsId = 0
  }
  @action openErrorModal(message, isInfo, informationWithAction, informationNoAction) {

    overFlowHidden()
    if (!!localStorage.getItem("dontOpenErrorModal")) {
      localStorage.removeItem("dontOpenErrorModal")
      return;
    } else this.errorModal = true,
      this.errorMessage = `${message}`
    this.isInfo = isInfo
    this.information = informationWithAction
    this.informationNoAction = informationNoAction
  }
  @action openLandingModal() {
    overFlowHidden()
  this.landingModal = true
     
  }
  @action openInfoModal(message) {
    overFlowHidden()
    // console.log("coming with a msg", message)
    this.infoModal = true,
      this.infoMessage = message
  }
  @action closeErrorModal() {
    removeOverFlowHidden()
    this.errorModal = false,
      this.errorMessage = ""
  }
  @action closeLandingModal() {
    removeOverFlowHidden()
    this.landingModal = false
      // this.errorMessage = ""
  }

  @action openChangePasswordForSecurity() {
    overFlowHidden()
    this.changePasswordForSecurity = true
  }

  @action closeChangePasswordForSecurity() {
    removeOverFlowHidden()
    this.changePasswordForSecurity = false
  }


  @action focusToArtworksFromToolbar() {
    this.toArtworks = true
  }
  @action removeFocusToArtworksFromToolbar() {

    this.toArtworks = false;
  }

  @action openSignInModal() {
    overFlowHidden()
    // console.log("navigator store signin modal open")
    this.showSignInModal = true;
    this.showSignUpModal = false;
  }


  @action openSignUpModal() {
    overFlowHidden()
    // console.log("navigator store signup modal open")
    this.showSignUpModal = true;
    this.showSignInModal = false;
  }
  @action closeSignInModal() {
    removeOverFlowHidden()
    this.showSignInModal = false;
    this.showSignUpModal = false;
  }

  @action closeSignUpModal() {
    removeOverFlowHidden()
    this.showSignUpModal = false;
    this.showSignInModal = false;
  }
}
export default new NavigatorStore();


// WEBPACK FOOTER //
// ./src/stores/navigatorStore.js